// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"0d3c6b22","345":"1018c1e8","398":"6c6b9125","481":"2bb30c90","505":"65324619","996":"bda88b03"}[chunkId] + ".chunk.css";
};